import { FeatureEnabledV2, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Component, Mixins } from 'vue-property-decorator';
import { Feature } from '@gig/magic-messages';

var UserRestrictionsModal = /** @class */ (function (_super) {
    __extends(UserRestrictionsModal, _super);
    function UserRestrictionsModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isUserRestrictionCustomModalEnabled = false;
        return _this;
    }
    UserRestrictionsModal.prototype.close = function () {
        this.$emit('close');
    };
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], UserRestrictionsModal.prototype, "content", void 0);
    __decorate([
        FeatureEnabledV2({ slug: Feature.USER_RESTRICTIONS_CUSTOM_MODAL }),
        __metadata("design:type", Object)
    ], UserRestrictionsModal.prototype, "isUserRestrictionCustomModalEnabled", void 0);
    UserRestrictionsModal = __decorate([
        Component({
            name: 'user-restrictions-modal',
        })
    ], UserRestrictionsModal);
    return UserRestrictionsModal;
}(Mixins(MagicConfigMixin)));

export default UserRestrictionsModal;
